import type { ReactElement } from 'react'

import { useTheme } from '@emotion/react'

import * as styles from './modal-split-layout.styles'

type Props = {
  start: ReactElement
  end: ReactElement
}

export const ModalSplitLayout = ({ start, end }: Props) => {
  const theme = useTheme()

  return (
    <div css={styles.root(theme)} data-testid="modal-split-layout">
      <section>{start}</section>
      <section css={styles.endSection(theme)}>{end}</section>
    </div>
  )
}
